var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuiltOnHedera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 435,
    viewBox: "0 0 1080 435",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_815_1506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.302 142.377H524.962C539.935 142.377 547.966 149.68 547.966 160.917C547.94 163.894 547.002 166.792 545.276 169.227C543.549 171.661 541.117 173.516 538.303 174.545C541.755 175.692 544.737 177.923 546.798 180.902C548.859 183.88 549.887 187.444 549.727 191.053C549.727 202.856 541.489 210.544 525.636 210.544H485.302V142.377ZM501.441 155.517V168.965H522.346C527.941 168.965 531.231 166.857 531.231 162.254C531.231 157.651 528.045 155.517 522.346 155.517H501.441ZM501.441 182.131V197.379H522.734C529.495 197.379 533.096 194.808 533.096 189.665C533.096 184.522 529.599 181.951 522.734 181.951L501.441 182.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.894 179.636V142.377H620.137V180.691C620.137 198.15 608.816 211.984 587.341 211.984C565.296 211.984 554.364 198.356 554.364 180.691V142.377H570.814V179.636C570.814 190.102 576.72 197.096 587.341 197.096C597.962 197.096 603.894 190.102 603.894 179.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.271 142.377H644.72V210.544H628.271V142.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.208 210.544H653.217V142.377H669.666V196.145H710.208V210.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.494 142.377H763.883V156.597H737.978V210.596H721.632V156.597H695.727L695.494 142.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.048 176.448C780.048 155.517 795.902 141.22 816.522 141.22C837.142 141.22 852.789 155.517 852.789 176.448C852.789 197.379 836.909 211.702 816.522 211.702C796.135 211.702 780.048 197.302 780.048 176.448ZM836.158 176.448C836.158 165.031 828.594 155.877 816.522 155.877C804.45 155.877 796.782 164.98 796.782 176.448C796.782 187.916 804.424 197.019 816.522 197.019C828.62 197.019 836.158 187.993 836.158 176.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.804 210.853H911.463L873.979 163.591V210.544H857.918V142.377H876.595L909.08 184.136V142.377H924.804V210.853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.078 6.08208e-06C262.42 -0.0101658 304.793 12.7387 340.836 36.6343C376.879 60.5299 404.973 94.4987 421.566 134.245C438.159 173.99 442.504 217.728 434.053 259.925C425.601 302.123 404.733 340.885 374.086 371.309C343.44 401.732 304.393 422.452 261.883 430.846C219.372 439.24 175.309 434.932 135.266 418.466C95.223 402.001 60.9984 374.117 36.921 338.343C12.8435 302.569 -0.00512115 260.51 1.53119e-06 217.487C0.00686871 159.813 23.0896 104.502 64.1723 63.7171C105.255 22.9326 160.974 0.013642 219.078 6.08208e-06ZM159.185 230.833H281.69V200.567H159.185V230.833ZM308.268 311.548H280.368V252.844H157.864V311.548H130.042V121.266H157.864V178.608H280.368V121.189H308.268V311.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.002 272.026H505.404V302.883H486.52V224.738H505.404V255.595H544.002V224.738H562.783V303.011H544.002V272.026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.498 224.738H638.478V240.167H591.279V254.284H619.36V269.995H591.279V286.76H642.7V302.96H572.498V224.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.689 224.738H679.355C704.561 224.738 722.565 238.187 722.565 263.875C722.565 289.126 704.561 303.011 679.355 303.011H646.689V224.738ZM665.574 240.835V286.914H679.019C693.551 286.914 703.343 278.429 703.343 263.772C703.343 248.652 693.551 240.63 679.019 240.63L665.574 240.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.315 224.738H794.295V240.167H747.2V254.284H775.307V269.995H747.2V286.76H798.621V302.96H728.315V224.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.637 224.738H848.825C866.259 224.738 876.932 233.095 876.932 249.321C877.206 254.092 875.884 258.819 873.171 262.767C870.459 266.715 866.508 269.663 861.933 271.152L879.704 303.011H859.835L843.178 273.235H821.495V303.011H802.637V224.738ZM821.495 240.835V257.472H846.83C853.825 257.472 857.607 254.721 857.607 249.321C857.607 243.355 853.928 240.835 846.83 240.835H821.495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.353 289.46H900.816L894.936 303.011H875.922L910.479 224.61H929.804L964.232 303.011H944.233L938.353 289.46ZM931.565 273.8L919.623 246.107L907.629 273.8H931.565Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_815_1506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 435,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuiltOnHedera);
export default __webpack_public_path__ + "static/media/built-on-hedera.1ae17be49b94e1d13a0089782b21f3d3.svg";
export { ForwardRef as ReactComponent };